module.exports = __webpack_public_path__ + "media/src/images/landing_icons/landing_features-04-d4b8eb516282bf650af19b2e10faf8e9.svg";